import { FreeNavigationMode } from './free-navigation-mode';
import { SemiStrictNavigationMode } from './semi-strict-navigation-mode';
import { StrictNavigationMode } from './strict-navigation-mode';
/**
 * A factory method used to create [[NavigationMode]] instances
 *
 * @param {WizardComponent} wizard The wizard, for which a navigation mode will be created
 * @param {WizardState} wizardState The wizard state of the wizard
 * @returns {NavigationMode} The created [[NavigationMode]]
 */
export function navigationModeFactory(navigationMode, wizardState) {
    switch (navigationMode) {
        case 'free':
            return new FreeNavigationMode(wizardState);
        case 'semi-strict':
            return new SemiStrictNavigationMode(wizardState);
        case 'strict':
        default:
            return new StrictNavigationMode(wizardState);
    }
}
;
//# sourceMappingURL=navigation-mode.provider.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ng2-archwizard/dist/navigation/navigation-mode.provider.js
// module id = ../../../../ng2-archwizard/dist/navigation/navigation-mode.provider.js
// module chunks = 3